export const getDaysInCurrentMonth = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  return new Date(year, month, 0).getDate();
};

export const getToday = () => {
  return new Date().toLocaleDateString(undefined, { day: "numeric" });
};

export const calculatePercentThruMonth = () => {
  return (getToday() / getDaysInCurrentMonth()).toFixed(2) * 100;
};
